import React from 'react'
import connect from "react-redux/es/connect/connect"
import {findOneBy} from '@relativity/js-util'
import {PERIOD_RULE_AT_TYPE_TITLE_MAP} from "redux/constants"

class BellRuleWarnings extends React.Component {
  render() {
    const {bellScheduleWarnings, atTypes} = this.props
    const hasDuplicates = bellScheduleWarnings && bellScheduleWarnings.atTypeDuplicates && bellScheduleWarnings.atTypeDuplicates.length > 0
    if (!hasDuplicates) return null

    return (
      <div style={{
        border: '2px solid #d32f2f',
        borderRadius: '8px',
        padding: '12px 16px',
        color: '#d32f2f',
        marginTop: '8px',
        marginBottom: '8px',
      }}>
        {bellScheduleWarnings.atTypeDuplicates.map((dup, i) => {
          const atType = findOneBy(atTypes, 'id', parseInt(dup.value))
          const atTypeLabel = atType ? atType.displayName : dup.value
          const fieldLabels = dup.fieldNames.map(fn => PERIOD_RULE_AT_TYPE_TITLE_MAP[fn] || fn)
          return <div key={i}>
            Attendance type "{atTypeLabel}" is assigned to multiple roles:
            <ul style={{margin: '4px 0 0 0'}}>
              {fieldLabels.map((label, j) => <li key={j}>{label}</li>)}
            </ul>
          </div>
        })}
      </div>
    )
  }
}

const mapStateToProps = state => ({
  atTypes: state.admin.atTypes,
})

export default connect(mapStateToProps)(BellRuleWarnings)
